module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_schlafzimmer_unten_02.8bfb58d0.jpg";